import { Alert, Button, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material"
import moment from "moment"
import { ChangeEvent, useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { DeviceType } from "../../services/ntuc/memberService/oaMembership"
import { FeeResponse, OrderRequest, postCreateOrder, ServiceType } from "../../services/ntuc/memberService/payment"
import { getMembershipPayment } from "../../services/ntuc/paymentService/payment"
import { ArrearsRouteProps } from "../../views/arrears-payment-flow/ArrearsPaymentFlow/ArrearsPaymentFlow"
import { FeeType } from "../MembershipFeePayment/MembershipFeePayment"

const MembershipPaymentSummary = (props: ArrearsRouteProps) => {
    const DECIMALS = 2
    const { t } = useTranslation(`arrears-payment`)
    const { routeParams } = props
    const [accept, setAccept] = useState(true)
    const setupRecurring = t(`setupRecurring`)
    const handleCheckBoxOnChange = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setAccept(checked)
    }

    const createOrder = (membershipId: number, fee: FeeResponse): OrderRequest => {
        return {
            feeType: fee.feeType,
            endDate: fee.endDate,
            startDate: fee.startDate,
            serviceType: fee.feeType == FeeType.Renewal ? ServiceType.RENEWAL : ServiceType.ARREARS,
            noOfMonths: fee.month,
            amount: fee.amount + ``,
            isOneTimePayment: true,
            isRecurringPayment: accept,
            membershipId: membershipId,
            deviceType: DeviceType.WEB,
            renewalCampaignCode: fee.renewalCampaignCode || undefined,
        }
    }
    const redirectToPaymentGateway = (clientOrderId: string) => {
        window.location.replace(getMembershipPayment(clientOrderId))
    }

    const getFeeTitle = (): string => {
        if (routeParams?.fee) {
            const fee = routeParams.fee
            return t(`unionMembership`, { months: fee.month })
        }
        return t(`unionMembershipNoMonths`)
    }

    const getDateRange = (): string => {
        if (routeParams?.fee) {
            const fee = routeParams.fee
            return `${moment(fee.startDate).format(`DD MMM YYYY`)} - ${moment(fee.endDate).format(`DD MMM YYYY`)}`
        }
        return ``
    }
    const getPrice = (): string => {
        if (routeParams?.fee) {
            const fee = routeParams.fee
            return `$` + `${fee.amount.toFixed(DECIMALS)}`
        }
        return ``
    }

    const handlePaymentButton = () => {
        if (window.myNtucConfig.membershipId && routeParams) {
            const order = createOrder(parseInt(window.myNtucConfig.membershipId), routeParams.fee)
            postCreateOrder(order)
                .then(response => response.data.content.clientOrderId)
                .then(redirectToPaymentGateway)
                .catch(error => error.response.data.content)
                .then(console.error)
        }
    }

    return (
        <Grid
            container
            rowSpacing={2}
            padding={6}
            columnSpacing={{
                xs: `16px`,
                sm: `24px`,
                md: `24px`,
                lg: `40px`,
            }}>
            <Grid item md={12} xs={12}>
                <Typography variant='h3' align='center' paddingBottom={5} >{t(`paymentSummary`)}</Typography>
            </Grid>
            <Grid item md={12} lg={12} xs={12} sm={12} >
                <Typography variant="body1">{t(`checkDetails`)}</Typography>
            </Grid>
            <Grid item md={12} lg={12} xs={12} sm={12} paddingBottom={2} />
            <Grid item md={12} lg={12} xs={12} sm={12} paddingBottom={1}>
                <Typography variant="h5">{t(`paymentDetails`)}</Typography>
            </Grid>
            <Grid item md={8} lg={8} xs={8} sm={8} >
                <Typography variant="body1">{getFeeTitle()}</Typography>
                <Typography variant="body1" color='text.secondary'>{getDateRange()}</Typography>
            </Grid>
            <Grid item md={4} lg={4} xs={4} sm={4} >
                <Typography variant="body1" align="right">{getPrice()}</Typography>
            </Grid>
            <Grid item md={12} lg={12} xs={12} sm={12} paddingBottom={1} />
            <Grid item md={8} lg={8} xs={8} sm={8}>
                <Typography variant="body1">{t(`total`)}</Typography>
            </Grid>
            <Grid item md={4} lg={4} xs={4} sm={4} >
                <Typography variant="body1" align="right">{getPrice()}</Typography>
            </Grid>
            <Grid
                container
                justifyContent="space-evenly"
                alignItems="center"
                paddingTop={5}>
                <FormControlLabel
                    control={<Checkbox checked={accept} onChange={handleCheckBoxOnChange} />}
                    label={setupRecurring} />
            </Grid>
            <Grid item md={12}>
                <Alert severity="info">
                    <Trans t={t}>paymentFooterInfo</Trans>
                </Alert>
            </Grid>
            <Grid
                container
                justifyContent="space-evenly"
                alignItems="center"
                paddingTop={5}>
                <Button variant="contained" color="primary" size="large" onClick={handlePaymentButton}>
                    {t(`proceedToPayment`)}
                </Button>
            </Grid>
        </Grid>
    )
}

export default MembershipPaymentSummary